import { MicrobiologyStorage } from './../../on-screen-results/microbiology-data/microbiology-storage';
import { Injectable } from '@angular/core';
import { MicrobiologyDataStorage } from '../../on-screen-results/microbiology-data/microbiology-data-storage';
import { Observable } from 'rxjs';
import { MicrobiologyData } from '../../on-screen-results/microbiology-data/microbiology-data';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { routeParams } from '../../shared/route-helpers';

@Injectable()
export class SponsorMicrobiologyStorage implements MicrobiologyDataStorage {
    constructor(private readonly route: ActivatedRoute, private storage: MicrobiologyStorage) {
    }

    public get siteMicrobiologyData(): Observable<MicrobiologyData[]> {
        const selectedSiteId = this.route.parent.params.pipe(map((p) => p[routeParams.siteId]));
        return this.storage.getMicrobiologyForSite(selectedSiteId);
    }
}